import { useSelector } from 'react-redux';

import {
  selectCartIsGroupOrder,
  selectIsGroupOrderCurrentDinerAdmin
} from 'bento-ordering/cart/selectors/index';

const useIsGroupOrderAdminDiner = () => {
  const isGroupOrder = useSelector(selectCartIsGroupOrder);
  const isCurrentDinerAdmin = useSelector(selectIsGroupOrderCurrentDinerAdmin);

  return isGroupOrder && isCurrentDinerAdmin;
};

export default useIsGroupOrderAdminDiner;
